import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SelectInput from "../../SelectInput/index";
import addRedirect from "./addRedirect";
import editDialog from "./editDialog";
export default {
  props: ['redirectList', "IpList", 'redirectLength', 'deleteOptions', "deviceDid", "deviceSn"],
  components: {
    SelectInput: SelectInput,
    addRedirect: addRedirect,
    editDialog: editDialog
  },
  data: function data() {
    return {
      SRCOptions: {
        'wan': 'wan',
        'lan': 'lan',
        '未指定': 'DROP'
      },
      protoOptions: {
        'TCP': 'TCP',
        'UDP': 'UDP',
        'TCP+UDP': 'TCP+UDP',
        'ICMP': 'ICMP',
        'all': 'All protocals'
      },
      isDisplay: [],
      IPOptions: [],
      loading: true,
      rLength: 0
    };
  },
  watch: {
    'redirectList': {
      immediate: true,
      handler: function handler(newVal) {
        var _this = this;

        if (this.redirectList.length > 0) {
          this.redirectList.forEach(function (item) {
            if (item.options.enabled === '1' || item.options.enabled) {
              item.options.enabled = true;
            } else {
              item.options.enabled = false;
            }

            _this.isDisplay.push('inline');
          });
        }
      }
    },
    'IpList': {
      immediate: true,
      deep: true,
      handler: function handler(newVal) {
        this.IPOptions = newVal;
      }
    },
    redirectLength: {
      immediate: true,
      handler: function handler() {
        if (this.redirectLength) {
          this.rLength = this.redirectLength;
        }
      }
    }
  },
  methods: {
    // 获取下拉框返回的值并更新到通信规则相应的数据中。
    IpSelectInput: function IpSelectInput(props, index) {
      this.redirectList[index[0]].options["".concat(index[1])] = props;
    },
    // 添加SNAT
    addRedirect: function addRedirect(value) {
      var redirectObj = value;
      redirectObj.index = this.rLength;
      this.rLength = this.rLength + 1;
      this.redirectList.push(redirectObj);
    },
    deleteRedirect: function deleteRedirect(row, index) {
      if (row.action == undefined) {
        // 不是后来添加的数据,若是原来的数据则保存到待删除数组中
        this.deleteOptions.push({
          index: row.index,
          options: row.options,
          sname: row.sname,
          action: 2
        }); // 在列表中删除

        this.redirectList.splice(index, 1);
      } else {
        // 不然直接在列表中删除即可
        this.redirectList.splice(index, 1);
      }
    },
    editRedirect: function editRedirect(row) {
      this.$refs.editDialog.show(row, row.index);
    },
    // 编辑后更新数据
    updateData: function updateData() {
      this.$emit('updateData');
    }
  }
};